import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
`;

const BlueListContainer = css`
  border: 1px solid ${({ theme }) => theme.colorPalette.turquoise.normal};

  > button {
    border: 0;
    padding: 0 10px;
    height: 30px;
    line-height: 25px;
    text-decoration: unset;
    text-align: left;
    border-radius: 0;
    font-weight: ${({ theme }) => theme.fontWeightPalette.light};
    font-size: ${({ theme }) => theme.fontSizePalette.small};
    color: ${({ theme }) => theme.colorPalette.grey.grey9};
    background-color: ${({ theme }) => theme.colorPalette.white};
    cursor: pointer;
    &:not([disabled]):hover {
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.normal : theme.colorPalette.turquoise.accent2};
    }
    align-items: center;
  }
`;

export const DropContainer = styled.div<{ visible: boolean; color?: string; left?: string }>`
  position: fixed;
  z-index: ${({ theme }) => theme.zIndexPalette.medium};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  > * {
    display: ${({ visible }) => (visible ? 'block' : 'none')};
  }
  flex-direction: column;
  margin-top: 5px;
  background-color: ${({ theme }) => theme.colorPalette.white};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 0px 4px 0 rgba(155, 155, 155, 0.23);
  min-width: 150px;
  ${({ color }) => color === 'blue' && BlueListContainer}
  left: ${({ left }) => left && left};
  border-radius: 2px;
  align-items: flex-start;
`;

export const ListButton = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  padding: 5px 0px 3px 8px;
  background-color: ${({ theme }) => theme.colorPalette.white};
  border-bottom: 1px solid rgb(197, 197, 197);
  letter-spacing: -0.4px;
  line-height: 19px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colorPalette.grey.grey2};
  }
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 100%;
`;

export const ListTitleButton = styled.span`
  cursor: pointer;
  font-size: 12px;
  margin-right: 5px;
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  letter-spacing: -0.4px;
  line-height: 14px;
  &Icon {
    color: ${({ theme }) => theme.colorPalette.turquoise.normal};
  }
  &Icon:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colorPalette.turquoise.dark};
  }
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;
